// Normalized API base: REACT_APP_API_URL (with or without /api) or same-origin /api
const RAW = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
export const API_BASE = RAW ? (RAW.endsWith("/api") ? RAW : `${RAW}/api`) : "/api";

function qs(params: Record<string, any> = {}) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    sp.append(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : "";
}

async function apiGet<T>(path: string, params?: Record<string, any>): Promise<T> {
  const res = await fetch(`${API_BASE}${path}${qs(params)}`, { credentials: "include" });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch {}
    throw new Error(msg);
  }
  return res.json() as Promise<T>;
}

// src/utils/publicApi.ts
export type PublicBusiness = {
  id: string;
  name: string;
  slug?: string;
  tagline?: string;
  description?: string;

  logoUrl?: string;
  website?: string;

  addressStreet?: string;
  addressCity?: string;
  addressZip?: string;
  addressCountry?: string;

  phonePublic?: string;
  hoursText?: string;

  categories?: string[];
  avgRating?: number;
  totalReviews?: number;
};


export type BusinessStats = {
  avgRating: number;
  totalReviews: number;
  distribution: { [star: number]: number };
};

export type PublicBusinessDetail = {
  business: Omit<PublicBusiness, "avgRating" | "totalReviews">;
  stats: BusinessStats;
};

export type PublicReview = {
  rating: number;
  comment: string;
  displayName: string;
  reply?: string;
  createdAt: string;
};

export async function searchBusinesses(params: {
  query?: string; city?: string; category?: string; page?: number; limit?: number;
}): Promise<{ page: number; results: PublicBusiness[] }> {
  return apiGet("/public/businesses", params);
}

export async function getBusiness(slugOrId: string): Promise<PublicBusinessDetail> {
  return apiGet(`/public/businesses/${encodeURIComponent(slugOrId)}`);
}

export async function getBusinessReviews(
  slugOrId: string,
  params: { sort?: "recent" | "top"; rating?: "all" | "1" | "2" | "3" | "4" | "5"; page?: number; limit?: number; }
): Promise<{ reviews: PublicReview[] }> {
  return apiGet(`/public/businesses/${encodeURIComponent(slugOrId)}/reviews`, params);
}
